function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#2b557c"
}, React.createElement("path", {
  d: "m3.23077 1.5c0 .82843-.7233 1.5-1.61539 1.5-.892085 0-1.61538-.67157-1.61538-1.5s.723295-1.5 1.61538-1.5c.89209 0 1.61539.67157 1.61539 1.5z"
}), React.createElement("path", {
  d: "m8.61539 1.5c0 .82843-.7233 1.5-1.61539 1.5s-1.61538-.67157-1.61538-1.5.72329-1.5 1.61538-1.5 1.61539.67157 1.61539 1.5z"
}), React.createElement("path", {
  d: "m12.3846 3c.8921 0 1.6154-.67157 1.6154-1.5s-.7233-1.5-1.6154-1.5-1.6154.67157-1.6154 1.5.7233 1.5 1.6154 1.5z"
}));

var SvgMeatballs = function SvgMeatballs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    height: 3,
    viewBox: "0 0 14 3",
    width: 14,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMeatballs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meatballs.4edb2e74.svg";
export { ForwardRef as ReactComponent };